export const redirectOnSignIn = (router) => {
    const redirectAfterAuth = window.localStorage.getItem("redirectAfterAuth");
    if (redirectAfterAuth) {
        router.push(redirectAfterAuth);
    }
    window.localStorage.removeItem("redirectAfterAuth");
};
